var map = {
	"./element-icons-logo-bbc.svg": "6e2e",
	"./element-icons-logo-hbo.svg": "bdc7",
	"./element-icons-logo-hbomax.svg": "fca4",
	"./element-icons-logo-wavve-only.svg": "90db",
	"./element-icons-logo-wavve-original.svg": "24c9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fb6e";